import eventManager from 'common/services/-RFC.eventManager';
import { DevicesRepository } from 'common/repositories/index';

/**
 * Listen events for Device Model
 */
angular.module('listeners')
    .service('DevicesListener', () => {

        eventManager.subscribe('socket:devices', (response) => {

            if (response.verb === 'POST') {

                DevicesRepository.add(response.payload.data);

            }

            if (response.verb === 'PUT') {

                DevicesRepository.update(response.payload.data);

            }

            if (response.verb === 'DELETE') {

                DevicesRepository.remove(response.payload.data.id);

            }

        });

    });



// WEBPACK FOOTER //
// ./scripts/common/listeners/devices.js